
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Solicitacao } from '@/types/solicitacao';
import { useClientFilter } from './useClientFilter';
import { useSolicitacoesTechnician } from './useSolicitacoesTechnician';

export const useSolicitacoesFetch = () => {
  const { currentClientId, isAdmin, isTechnician, clientLoading } = useClientFilter();
  
  
  const technicianData = useSolicitacoesTechnician();
  
  // Se é técnico, usar dados específicos para técnicos
  if (isTechnician) {
    return {
      solicitacoes: technicianData.solicitacoes,
      isLoading: technicianData.isLoading,
      error: technicianData.error,
    };
  }

  // Para outros usuários, manter lógica original
  const { applyClientFilter } = useClientFilter();
  
  const { data: solicitacoes = [], isLoading, error } = useQuery({
    queryKey: ['solicitacoes', currentClientId, isAdmin],
    queryFn: async () => {
      
      let query = supabase
        .from('solicitacoes')
        .select(`
          *,
          categoria:categorias_servico(nome),
          sla:slas(nome),
          solicitante:users!solicitacoes_solicitante_id_fkey(name),
          cliente:clients(name),
          grupo_responsavel:groups(name),
          atendente:users!solicitacoes_atendente_id_fkey(name)
        `);

      // Aplicar filtro de cliente usando o useClientFilter
      query = applyClientFilter(query, 'client_id');

      const { data, error } = await query.order('criado_em', { ascending: false });

      if (error) {
        throw error;
      }
      
      return data as Solicitacao[];
    },
    enabled: !clientLoading, // Só executa quando o cliente já foi carregado
  });

  return {
    solicitacoes,
    isLoading,
    error,
  };
};
